import { render, staticRenderFns } from "./RelatieApiKeys.vue?vue&type=template&id=6ed0a2e5"
import script from "./RelatieApiKeys.vue?vue&type=script&lang=js"
export * from "./RelatieApiKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports